import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import CvrUpload from "@/types/CvrUpload";
import ConfirmationModal from "@/components/Common/ConfirmationModal.vue";
import NotificationModal from "@/components/Common/NotificationModal.vue";
import { ref } from 'vue';
import Api from "@/services/api/ApiServiceFabrick";
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'RemoveButton',
  props: {
    item: {},
    reload: { type: Function },
    showFlash: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const requesting = ref(false);
const notificationModalTitle = ref("")
const notificationModalState = ref(false)
const confirmationModalTitle = ref("")
const confirmationModalState = ref(false)

async function remove() {
  requesting.value = true;
  const res = await Api().removeCvrUpload(props.item.id).catch((error) => {
    console.log(error);
  });
  if (res) {
    props.showFlash(
      i18n.global.t('pages.cvr_uploads.removeMessages.success'),
      "success",
      true
    );
    props.reload()
  }
  requesting.value = false;
}

function exec() {
  if (props.item.hold) {
    showNotification()
  } else {
    showConfirmation()
  }
}

function showNotification() {
  notificationModalState.value = true;
  notificationModalTitle.value = i18n.global.t('pages.cvr_uploads.removeMessages.notificationModalTitle');
}

function closeNotification() {
  notificationModalState.value = false;
  notificationModalTitle.value = "";
}

function showConfirmation() {
  confirmationModalState.value = true;
  confirmationModalTitle.value = i18n.global.t('pages.cvr_uploads.removeMessages.confirmationModalTitle');
}

function closeConfirmation() {
  confirmationModalState.value = false;
  confirmationModalTitle.value = "";
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_btn, {
      onClick: exec,
      class: "bg-danger text-white"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.cvr_uploads.removeBtn')), 1)
      ]),
      _: 1
    }),
    _createVNode(NotificationModal, {
      title: notificationModalTitle.value,
      titleClass: "remove-modal-notification-title",
      modalState: notificationModalState.value,
      modalMaxWidth: "40%",
      onClick: closeNotification,
      loading: requesting.value
    }, null, 8, ["title", "modalState", "loading"]),
    _createVNode(ConfirmationModal, {
      title: confirmationModalTitle.value,
      titleClass: "remove-modal-confirmation-title",
      modalState: confirmationModalState.value,
      confirmBtnName: _unref(i18n).global.t('pages.cvr_uploads.removeMessages.confirmationModalBtnLabel'),
      confirmBtnClass: "bg-danger text-white",
      modalMaxWidth: "40%",
      onConfirm: remove,
      onCancel: closeConfirmation,
      loading: requesting.value
    }, null, 8, ["title", "modalState", "confirmBtnName", "loading"])
  ], 64))
}
}

})